import { Card } from 'react-bootstrap'
import areaMontaje from '../../assets/img/providers/AreaMontaje.webp';

const EcomStoreReviewsTable = () => {
 // const { storeId } = useParams() // Get store ID from URL
  //const { isAuthenticated } = useAuth0() // Check if the user is authenticated
 // const [openReviewModal, setOpenReviewModal] = useState(false)
 // const { showModal, /*handleShowModal,*/ handleCloseModal } = useModal() // custom hook for modal use
 // const [reviews, setReviews] = useState<ReviewType[]>([]) // Local state to manage new reviews

  // Find the store by ID and retrieve its reviews
  //const store = stores.find((store) => store.id === storeId)
 // const currentReviews = store ? store.reviews : []

  // Combine current reviews with new reviews
  //const allReviews = [...currentReviews, ...reviews]

  // Calculate the average rating from all reviews
  // const averageRating = (
  //   allReviews.reduce((acc, review) => acc + review.star, 0) / allReviews.length
  // ).toFixed(1)

  // Function to handle adding a new review
  // const addReview = (review: ReviewType) => {
  //   setReviews((prevReviews) => [...prevReviews, review])
  // }
  // function to handle adding a new review, open the review modal, or show the login/register modal depending on udser authentication status
  // const handleAddReviewClick = () => {
  //   if (!isAuthenticated) {
  //     handleShowModal() // Show Login/Register modal
  //   } else {
  //     setOpenReviewModal(true) // Open Review modal
  //   }
  // }

  return (
    <Card>
      {/* <Card.Header className="pb-0 border-bottom-0">
        <Stack
          gap={3}
          direction="horizontal"
          className="flex-wrap justify-content-between"
        >
          <div className="d-flex align-items-center flex-wrap">
            <h2 className="fw-bolder me-3">
              {averageRating}
              <span className="fs-8 text-500 fw-bold">/5</span>
            </h2>
            <div className="me-3">
              <Rating
                initialValue={parseFloat(averageRating)}
                readonly
                iconClass="fs-6"
                onChange={() => {}}
              />
            </div>
            <p className="text-900 mb-0 fw-semi-bold fs-7">
              {allReviews.length} Calificaciones
            </p>
          </div>
          <Button
            variant="primary"
            className="rounded-pill"
            onClick={handleAddReviewClick}
          >
            Agregar una Calificación
          </Button>
        </Stack>
      </Card.Header> */}

      <Card.Body style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
        <img
          src={areaMontaje}
          alt="areaMontaje"
          style={{
            width: "50%",
            height: "50%",
          }}
        />

        <p style={{fontWeight: 700, paddingTop: 25}}> En Construcción... pero casi lista</p>
        <p> Muy pronto podras ver calificaciones y rese;as de tus proveedores favoritos</p>

      </Card.Body>

      {/* Review Modal */}
      {/* <ReviewModal
        show={openReviewModal}
        handleClose={() => setOpenReviewModal(false)}
        onSubmit={addReview} // Pass the addReview function to the modal
      />
      <LoginRegisterModal show={showModal} onHide={handleCloseModal} /> */}
    </Card>
  )
}

export default EcomStoreReviewsTable
